import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams, Link } from "react-router-dom";
import { getBlog } from "../api/blogAPI";
import { PageContentSkeleton } from "../components/LoadingSkeleton";

const BlogItem = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true); // Adding loading state

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const blogData = await getBlog(id);
        setBlog(blogData || null);
        setError(null);
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error("Error fetching blog:", error);
        }
        setError("Failed to load blog.");
      } finally {
        setLoading(false); // Stop loading once data is fetched
      }
    };

    fetchBlog();
  }, [id]);

  return (
    <>
      <Helmet>
        <title>
          {blog
            ? `${blog.title} | David Seibold - Blog`
            : "Loading Blog | David Seibold - Blog"}
        </title>
        <meta
          name="description"
          content={
            blog ? `Read about ${blog.title}` : "Loading blog content..."
          }
        />
        {/* <meta
          property="og:url"
          content={`https://daveyrockets.me/blogs/${blog.id}`}
        /> */}
      </Helmet>

      {loading ? (
        <PageContentSkeleton />
      ) : error ? (
        <div className="text-red-500 text-center">{error}</div>
      ) : !blog ? (
        <div className="text-gray-700 dark:text-brand-cream text-center text-[18px]">Loading...</div>
      ) : (
        <div className="container mx-auto p-6 max-w-[800px] text-gray-800 dark:text-brand-cream">
          <h1 className="text-[36px] md:text-[55px] font-bold text-center text-gradient mb-6 md:mb-8">
            {blog.title}
          </h1>
          <div className="bg-white dark:bg-brand-darker p-8 rounded-lg shadow-lg min-h-[400px] border border-gray-200 dark:border-gray-700">
            <p className="text-gray-700 dark:text-brand-cream text-[18px] md:text-[20px] text-left leading-relaxed mb-6 md:mb-8">
              {blog.content}
            </p>
            <div className="text-center mt-8">
              <Link
                to="/blogs"
                className="text-brand-gold hover:text-brand-gold/80 text-[18px] transition-colors"
              >
                Back to Blogs
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BlogItem;
